import React, { useRef } from 'react';

const HolographicCard = ({ children, className = '', provider = '', disabled = false }) => {
  const cardRef = useRef(null);
  const rafRef = useRef(null);

  if (disabled) {
    return (
      <div className={`holo-card holo-card--flat ${provider} ${className}`}>
        <div className="holo-card-inner">{children}</div>
      </div>
    );
  }

  const applyPosition = (clientX, clientY) => {
    if (!cardRef.current || rafRef.current) return;
    rafRef.current = requestAnimationFrame(() => {
      rafRef.current = null;
      if (!cardRef.current) return;
      const card = cardRef.current;
      const rect = card.getBoundingClientRect();
      const x = clientX - rect.left;
      const y = clientY - rect.top;
      const rotateX = (y - rect.height / 2) / 10;
      const rotateY = (rect.width / 2 - x) / 10;
      card.style.setProperty('--x', `${x}px`);
      card.style.setProperty('--y', `${y}px`);
      card.style.setProperty('--bg-x', `${(x / rect.width) * 100}%`);
      card.style.setProperty('--bg-y', `${(y / rect.height) * 100}%`);
      card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    });
  };

  const resetCard = () => {
    if (rafRef.current) { cancelAnimationFrame(rafRef.current); rafRef.current = null; }
    if (!cardRef.current) return;
    const card = cardRef.current;
    card.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg)';
    card.style.setProperty('--x', '50%');
    card.style.setProperty('--y', '50%');
    card.style.setProperty('--bg-x', '50%');
    card.style.setProperty('--bg-y', '50%');
  };

  // ── Mouse ──────────────────────────────────────────────────────────────────
  const handleMouseMove  = (e) => applyPosition(e.clientX, e.clientY);
  const handleMouseLeave = () => resetCard();

  // ── Touch ──────────────────────────────────────────────────────────────────
  const handleTouchStart = (e) => {
    cardRef.current?.classList.add('holo-card--touching');
    const t = e.touches[0];
    applyPosition(t.clientX, t.clientY);
  };

  const handleTouchMove = (e) => {
    const t = e.touches[0];
    applyPosition(t.clientX, t.clientY);
  };

  const handleTouchEnd = () => {
    cardRef.current?.classList.remove('holo-card--touching');
    resetCard();
  };

  return (
    <div
      ref={cardRef}
      className={`holo-card ${provider} ${className}`}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div className="holo-card-inner">
        {children}
      </div>
      <div className="holo-glow" />
    </div>
  );
};

export { HolographicCard };
